import React, { Component } from 'react';


export default class Bottom extends Component{

	/*constructor(props){
		super(props);


	}*/

	render(){

	

		return (
			<section className="content_bottom"></section>

		);

	}

}



// WEBPACK FOOTER //
// ./src/Components/Content/Bottom/index.js